export const HeaderName = {
  Authorization: 'Authorization',
  BusinessUnit: 'current-business-unit'
} as const
